'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    // Redireciona para a home após rota inválida
    router.replace('/');
  }, [router]);

  return null; // Pode mostrar um loading se quiser
}